import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";

// Bloque l'accès aux pages boutique quand la boutique est désactivée dans le back-office.
export default function ShopGate({ children }) {
  const [state, setState] = useState("loading"); // loading | on | off
  useEffect(() => {
    api.get("/site-info").then((r) => setState(r.data?.shop_enabled ? "on" : "off")).catch(() => setState("off"));
  }, []);
  if (state === "loading") return <div className="min-h-[50vh]" />;
  if (state === "off") return <Navigate to="/" replace />;
  return children;
}
